import React, { memo } from 'react'
import { Checkbox } from 'components/forms/Checkbox'
import PropTypes from 'prop-types'
import { Button } from 'transfix-ui/components/Button'
import { Box } from 'transfix-ui/core'
import uuid from 'uuid/v4'
import { useToggle } from 'utils/useToggle'
import 'scss/5_components/_dropdown.scss'

export const CheckboxDropdown = memo(
  ({ allSelectedText, dataTest, defaultText, dropdownId, handleChange, options }) => {
    const [expanded, toggle, wrapperRef] = useToggle()

    const selectedList = options.filter(o => o.selected).map(o => o.text)
    const selectedLength = selectedList.length
    let inputText = defaultText

    if (selectedLength) {
      if (selectedLength === options.length && allSelectedText) {
        inputText = allSelectedText
      } else {
        inputText = selectedList.join(', ')
      }
    }

    let listBoxClassName = 'dropdown-listbox dropdown-listbox--left'
    if (!expanded) listBoxClassName += ' dn'

    const onChange = e => {
      handleChange(options[e.target.value])
    }

    return (
      <div className='dropdown' ref={wrapperRef}>
        <button
          className='dropdown-select ellipsis'
          type='button'
          aria-haspopup='listbox'
          id={dropdownId}
          onClick={toggle}
          data-test={dataTest}>
          {inputText}
        </button>

        <ul role='listbox' className={listBoxClassName}>
          {options.map((option, idx) => (
            <li
              role='option'
              tabIndex='-1'
              key={`checkbox-dropdown-${dropdownId}-option-${option.value}`}
              aria-selected={option.selected}
              className='dropdown-listbox-item'>
              <Checkbox
                tabIndex='0'
                dataTest={`${dataTest}-${option.value}`}
                checked={option.selected}
                label={option.text}
                value={idx}
                id={`checkbox-dropdown-${dropdownId}-option-${option.value}`}
                onChange={onChange}
              />
            </li>
          ))}
          <Box p={1} pt={0}>
            <Button color='tertiary' fullWidth onClick={toggle}>
              Close
            </Button>
          </Box>
        </ul>
      </div>
    )
  }
)

CheckboxDropdown.propTypes = {
  defaultText: PropTypes.string,
  allSelectedText: PropTypes.string,
  dataTest: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      selected: PropTypes.bool.isRequired,
    })
  ).isRequired,
  handleChange: PropTypes.func,
  dropdownId: PropTypes.string, // use to share events between multiple instances
}

CheckboxDropdown.defaultProps = {
  handleChange: null,
  dropdownId: uuid(),
  defaultText: 'Select an Option',
  dataTest: 'checkbox-dropdown',
  allSelectedText: '',
}

export default CheckboxDropdown
